var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28C10.3431 28 7.51472 28 5.75736 26.2426C4 24.4853 4 21.6569 4 16C4 10.3431 4 7.51472 5.75736 5.75736C7.51472 4 10.3431 4 16 4C21.6569 4 24.4853 4 26.2426 5.75736C28 7.51472 28 10.3431 28 16C28 21.6569 28 24.4853 26.2426 26.2426C24.4853 28 21.6569 28 16 28ZM20.8364 12.3636C21.1879 12.7151 21.1879 13.2849 20.8364 13.6364L14.8364 19.6364C14.4849 19.9879 13.9151 19.9879 13.5636 19.6364L11.1636 17.2364C10.8121 16.8849 10.8121 16.3151 11.1636 15.9636C11.5151 15.6121 12.0849 15.6121 12.4364 15.9636L14.2 17.7272L19.5636 12.3636C19.9151 12.0121 20.4849 12.0121 20.8364 12.3636Z",
    fill: "#00B67A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/CheckSquare.412df083deea79c76d4246b5b81e4a71.svg";
export { ForwardRef as ReactComponent };